<template>
    <b-container fuild>
        <b-row>
            <b-col cols="12" md="4">
                <match-container-wrapped :match="matchRequest.match"></match-container-wrapped>
            </b-col>
            <b-col cols="12" md="4">
                <b-list-group class="shadow">
                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="small">Prezzo biglietto</div>
                            <div class="ml-auto">{{matchRequest.match.price | currency}}</div>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="small">Settore</div>
                            <div class="ml-auto">{{matchRequest.sector.name}}</div>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="small">Posti liberi settore</div>
                            <div class="ml-auto">{{getFreePercent(sectorBusySeats, sectorTotalSeats) | percent}}</div>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="small">Stato richiesta</div>
                            <div class="ml-auto">
                                <h5 class="my-0 text-uppercase">
                                    <b-badge class="px-2" :variant="requestStatus.variant">
                                        {{requestStatus.label}}
                                    </b-badge>
                                </h5>
                            </div>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="small">Data Richiesta</div>
                            <div class="ml-auto">{{matchRequest.created_at | date}}</div>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="small">Tipo Pagamento</div>
                            <div class="ml-auto text-uppercase">{{matchRequest.payment_method}}</div>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col cols="12" md="4" class="d-flex flex-column">
                <b-list-group class="shadow">

                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="small">Biglietti Accompagnatori</div>
                            <div class="ml-auto">
                                <h5 class="my-0">
                                    <b-badge variant="secondary">
                                        <i class="fi flaticon-employee mr-2"></i> {{seniorTickets}}
                                    </b-badge>
                                </h5>
                            </div>
                        </div>
                    </b-list-group-item>

                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="small">Biglietti Atleti</div>
                            <div class="ml-auto">
                                <h5 class="my-0">
                                    <b-badge variant="primary">
                                        <i class="fi flaticon-baby mr-2"></i> {{juniorTickets}}
                                    </b-badge>
                                </h5>
                            </div>
                        </div>
                    </b-list-group-item>
                </b-list-group>

                <b-list-group class="mt-auto shadow">
                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="text-primary text-uppercase">biglietti</div>
                            <div class="ml-auto">{{matchRequest.details.length}}</div>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item>
                        <div class="d-flex align-items-center">
                            <div class="text-primary text-uppercase">Importo</div>
                            <div class="ml-auto">{{matchRequest.amount | currency}}</div>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import MatchContainerWrapped from "../../../../components/match/match-container-wrapped/MatchContainerWrapped";
    import MatchRequest from '@/models/MatchRequest';

    export default {
        name: "SocietyMatchesRequestDetails",
        components: {MatchContainerWrapped},
        props: {
            matchRequest: {
                type: Object,
                default: () => Object.assign({}, MatchRequest)
            },
            sectorBusySeats: {
                type: Number,
                default: 0
            },
            sectorTotalSeats: {
                type: Number,
                default: 0
            },
            extraJunior: {
                type: Number,
                default: 0
            },
            juniorTickets: {
                type: Number,
                default: 0
            },
            seniorTickets: {
                type: Number,
                default: 0
            },
            requestStatus: {
                type: Object,
                default: () => ({variant: '', label: ''})
            }
        },
        methods: {
            getFreePercent: function(busy, total) {
                return Math.round(100*(total-busy) / total);
            }
        },
        data() {
            return {}
        },
        computed: {

            sectorAvailableSeats: function () {
                return this.sectorTotalSeats - this.sectorBusySeats;
            },
        },
    }
</script>

<style scoped>

</style>
